/** Referencias CSS var para uso en TypeScript (bindings inline, APIs de terceros). */
export const THEME_COLOR_VARS = {
    statusScheduled: 'var(--status-scheduled)',
    statusDone: 'var(--status-done)',
    statusInProgress: 'var(--status-in-progress)',
    statusNotDone: 'var(--status-not-done)',
    statusWarning: 'var(--status-warning)',
    statusInformed: 'var(--status-informed)',
    colorCritical: 'var(--color-critical)',
    colorPrimary: 'var(--color-primary)',
    colorSecondary: 'var(--color-secondary)',
    colorTextSecondary: 'var(--color-text-secondary)',
} as const;
